import { ApiError } from "@aurumiq/api-client";
import { QueryClient } from "@tanstack/react-query";

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (count, err) =>
          count < 2 &&
          !(
            err instanceof ApiError &&
            (err.status === 401 || err.status === 403 || err.status === 404)
          ),
        refetchOnWindowFocus: false,
      },
    },
  });
}
